import { TruckImplementJourney } from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-journey-tab/TruckImplementJourney';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import React from 'react';
import { Switch } from 'react-router-dom';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute path={`${match.url}/:id/alerts`} component={TruckImplementJourney} />
    </Switch>
  </>
);

export default Routes;
